import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ReleaseNote from "./pages/ReleaseNote";
import { Toaster } from "react-hot-toast";
import AdminRoutes from "./pages/Admin/AdminRoutes";
import ParticipantRoutes from "./pages/Participant/ParticipantRoutes";
import { ReactQueryDevtools } from "react-query/devtools";
import AccountSetup from "./pages/Admin/pages/accountSetup/AccountSetup";
import NotFound from "./pages/NotFound";
import Login from "./pages/Auth/Login";
import AzureCallbackPage from "./pages/Auth/AzureCallbackPage";

function App() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("/admin/")) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
    document.querySelectorAll("*").forEach((element) => {
      element.scroll({ top: 0, left: 0, behavior: "instant" });
    });
  }, [location.pathname]);

  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/auth/azure/callback" element={<AzureCallbackPage />} />
        <Route path="/LR_release_note" element={<ReleaseNote />} />
        
        <Route path="/participant/*" element={<ParticipantRoutes />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
        
        <Route path="/account-setup" element={<AccountSetup />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster containerClassName="text-xs" />
      <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />
    </React.Fragment>
  );
}

export default App;
